/**
 * Theme resolution for widgets.
 *
 * Precedence:
 *   1. Explicit `?theme=light|dark` URL param (lets the demo route force-flip
 *      without changing host context).
 *   2. `window.openai.theme` if ChatGPT injected one.
 *   3. `prefers-color-scheme` media query.
 *
 * We default to dark to match the platform UI when no signal is available.
 */

export type Theme = 'light' | 'dark';

export function resolveTheme(): Theme {
  if (typeof window === 'undefined') return 'dark';

  const params = new URLSearchParams(window.location.search);
  const forced = params.get('theme');
  if (forced === 'light' || forced === 'dark') return forced;

  if (window.openai?.theme === 'light' || window.openai?.theme === 'dark') {
    return window.openai.theme;
  }

  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) return 'light';
  return 'dark';
}

/** Apply a theme to <html>. Used at mount time and by the demo theme toggle. */
export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.toggle('light', theme === 'light');
  root.classList.toggle('dark', theme === 'dark');
}
